import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'bizflex-error-page-offer-expired',
  standalone: true,
  imports: [],
  templateUrl: './offer-expired.component.html',
  styleUrls: ['./offer-expired.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferExpiredComponent {
  @HostBinding('class') private readonly hostClass = 'portal-section text-center';
}
